import AppNavbar from "@/components/layout/AppNavbar";
import Footer from "@/components/layout/Footer";

import { Col } from "react-bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "@/assets/css/style.css";

function Cookies() {
  return (
    <>
      <AppNavbar />
      <main className="container-lg nav-padding">
        <Col lg={{ span: 8, offset: 2 }} className="py-5">
          <h2 className="mb-4">Cookies Policy</h2>
          <p>Effective Date: January 1st, 2025</p>

          <p>
            This Cookies Policy explains how Wishcan Inc. ("we," "us," or "our")
            uses cookies and similar technologies to recognize you when you
            visit our social network, Favluv ("Site"). It explains what these
            technologies are and why we use them, as well as your rights to
            control their use.
          </p>

          <h3 className="mt-4 mb-3">1. What are cookies?</h3>
          <p>
            Cookies are small data files that are placed on your computer or
            mobile device when you visit a website. Cookies are widely used by
            website owners to make their websites work, or to work more
            efficiently, as well as to provide reporting information.
          </p>
          <p>
            Cookies set by the website owner (in this case, Wishcan Inc.) are
            called "first-party cookies." Cookies set by parties other than the
            website owner are called "third-party cookies." Third-party cookies
            enable third-party features or functionality to be provided on or
            through the website (e.g., like advertising, interactive content,
            and analytics). The parties that set these third-party cookies can
            recognize your computer both when it visits the website in question
            and also when it visits certain other websites.
          </p>

          <h3 className="mt-4 mb-3">2. Why do we use cookies?</h3>
          <p>
            We use first- and third-party cookies for several reasons. Some
            cookies are required for technical reasons for our Site to operate,
            and we refer to these as "essential" or "strictly necessary"
            cookies. Other cookies enable us to track and target the interests
            of our users to enhance the experience on our Site. Third parties
            serve cookies through our Site for advertising, analytics, and other
            purposes. This is described in more detail below.
          </p>

          <h3 className="mt-4 mb-3">3. The cookies we use</h3>
          <ul>
            <li>
              <strong>Essential cookies:</strong> These cookies are necessary to
              provide you with services available through our Site and to use
              some of its features, such as access to secure areas.
            </li>
            <li>
              <strong>Performance and functionality cookies:</strong> These
              cookies are used to enhance the performance and functionality of
              our Site but are non-essential to its use. However, without these
              cookies, certain functionality (like personalized settings) may
              become unavailable.
            </li>
            <li>
              <strong>Analytics and customization cookies:</strong> These
              cookies collect information that is used either in aggregate form
              to help us understand how our Site is being used or how effective
              our marketing campaigns are, or to help us customize our Site for
              you.
            </li>
            <li>
              <strong>Advertising cookies:</strong> These cookies are used to
              make advertising messages more relevant to you. They perform
              functions like preventing the same ad from continuously
              reappearing, ensuring that ads are properly displayed, and in some
              cases selecting advertisements that are based on your interests.
            </li>
          </ul>

          <h3 className="mt-4 mb-3">4. How can you control cookies?</h3>
          <p>
            You have the right to decide whether to accept or reject cookies.
            You can exercise your cookie preferences by clicking on the "Cookie
            Settings" button displayed on the Site.
          </p>
          <p>
            You can set or amend your web browser controls to accept or refuse
            cookies. If you choose to reject cookies, you may still use our Site
            though your access to some functionality and areas of our Site may
            be restricted. As the means by which you can refuse cookies through
            your web browser controls vary from browser to browser, you should
            visit your browser's help menu for more information.
          </p>
        </Col>
      </main>
      <Footer />
    </>
  );
}

export default Cookies;
